export interface InventoryState {
  isBulkUpdateModalOpen: boolean
  adjustVariantId: number | null
  movementsVariantId: number | null
  // Only used by weppa users, the rest are bound to their marketplace
  marketplaceId: string | null
  commercialAllyId: string | null
  threshold: number
}

export const initialState: InventoryState = {
  isBulkUpdateModalOpen: false,
  adjustVariantId: null,
  movementsVariantId: null,
  marketplaceId: null,
  commercialAllyId: null,
  threshold: 5
}
